import { Injectable } from '@angular/core';
import * as moment from 'moment';
import {APIError} from '../shared.models';

@Injectable()
export class UtilsService {

    /**
     * Function fires onBlur event of last update to calculate the next update date based on the update frequency
     */
    getNextUpdateDate(lastReceived: string, frequency: string): string {

        let nextUpdateDate = moment();
        let lastUpdateDate = moment(lastReceived);

        switch (frequency) {
            case 'Annual':
                nextUpdateDate = lastUpdateDate.add(1, 'years');
                break;
            case 'Bi_Annual':
                nextUpdateDate = lastUpdateDate.add(6, 'months');
                break;
            case 'Quarterly':
                nextUpdateDate = lastUpdateDate.add(3, 'months');
                break;
            case 'Six_Weeks':
                nextUpdateDate = lastUpdateDate.add(6, 'weeks');
                break;
            case 'Monthly':
                nextUpdateDate = lastUpdateDate.add(1, 'months');
                break;
            case 'Weekly':
                nextUpdateDate = lastUpdateDate.add(1, 'weeks');
                break;
            default:
                // Default to annual update
                nextUpdateDate = lastUpdateDate.add(1, 'years');
        }

        // Set nextUpdate to date string so it can be saved
        return nextUpdateDate.format('YYYY-MM-DD');
    }

    /**
     * Handle the error from the API in a consistent way
     * Create defaults in case the API doesn't return what we expect
     * TODO: create shared component for HTML bit
     * @param errorFromAPI
     * @returns {APIError}
     */
    handleAPIError(errorFromAPI): APIError {

        let apiError = new APIError();
        apiError.hasError = true;

        if (errorFromAPI.error) {
            if (errorFromAPI.error.errorMessage) {
                apiError.errorMessage = errorFromAPI.error.errorMessage;
            }
        }

        return apiError;
    }
}
